import type { CardDirection, FlowThemeCardMotion } from '../../cardMotion';

/** The card is pressed into place like a tile, settling with a small bounce; the last one lifts away. */
export const mosaicCardMotion = (isMobile: boolean): FlowThemeCardMotion => ({
  variants: {
    enter: (direction: CardDirection) => ({ opacity: 0, scale: 1.06, rotate: direction > 0 ? 1.4 : -1.4, y: isMobile ? -10 : -16 }),
    center: { opacity: 1, scale: 1, rotate: 0, y: 0 },
    exit: (direction: CardDirection) => ({ opacity: 0, scale: 0.94, rotate: direction > 0 ? -1 : 1, y: isMobile ? 8 : 12 }),
  },
  transition: { duration: 0.8, ease: [0.34, 1.4, 0.64, 1] },
});
